import { createVanIconComponent } from "./van"

const CartOutlined = createVanIconComponent("cart-o")
export default CartOutlined
